import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { v4 as uuid } from 'uuid';
import { Vacancy } from '../types';

export const CREATE_VACANCY = 'CREATE_VACANCY';
export const CREATE_VACANCY_SUCCESS = 'CREATE_VACANCY_SUCCESS';

export interface CreateVacancy {
    type: typeof CREATE_VACANCY;
    payload: {
        request: AxiosRequestConfig;
    };
}

export interface CreateVacancySuccess {
    type: typeof CREATE_VACANCY_SUCCESS;
    payload: AxiosResponse<Vacancy>;
}

export const createVacancy = (): CreateVacancy => {
    const vacancy: Vacancy = {
        id: uuid(),
        name: 'Vacancy name',
        creationDate: new Date(),
        hiringManagers: [],
        questions: [],
        candidates: [],
        vacancyLinks: [],
    };

    const createVacancyAction: CreateVacancy = {
        type: CREATE_VACANCY,
        payload: {
            request: {
                method: 'PUT',
                url: `/administrator/vacancies/${vacancy.id}`,
                data: vacancy,
            },
        },
    };

    return createVacancyAction;
};



// WEBPACK FOOTER //
// ./src/scenes/administrator/actions/create-vacancy-action.ts